"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var gl = (window || global || {});
// define _GIPHY_SDK_PARAMS if they don't exist
gl._GIPHY_SDK_PARAMS = gl._GIPHY_SDK_PARAMS || { 'x-giphy-sdk-platform': 'web' };
exports.getGiphySDKRequestParams = function () { return gl._GIPHY_SDK_PARAMS; };
exports.appendGiphySDKRequestParam = function (key, value) {
    exports.getGiphySDKRequestParams()[key] = value;
};
//# sourceMappingURL=sdk-params.js.map